/**
 * Версия используемого API.
 */
export const API_VERSION = '1.2.0';

// v1.1.0 - в ряд методов добавлен параметр captcha
// v1.2.0 - проекты грузятся постранично: /projects?scope=... и /projects/summary,
//          отчеты архивного проекта подтягиваются по клику через /project/:id
